import React, { useRef } from 'react';
import { createPortal } from 'react-dom';

import { Post, type IPost } from '../../components/Post';
import { DealsLeadFormBlock, type IDealsLeadFormBlockProps } from '../../components/DealsLeadForm';
import { DealsBanner, type IDealsBannerProps } from '../../components/DealsBanner';
import { useFindDealsBannerMountNode, usePlaceBeforeTrailingCaption } from './hooks';

/**
 * Встраивает форму и баннер Сделки в HTML статьи через порталы.
 * Форма — перед хвостовыми `.caption` (или в конце контента, если caption нет),
 * баннер — в маркер `data-name="deal-experiment-banner"`.
 * Рендерится только когда useDealsExperiment решил показать виджеты.
 */
export const PostWithDealsWidgets = ({
  dealsLeadForm,
  dealsBanner,
  dealsBannerContainerId,
  postProps,
}: {
  dealsLeadForm: IDealsLeadFormBlockProps;
  dealsBanner: IDealsBannerProps | undefined;
  dealsBannerContainerId: string | null;
  postProps: IPost;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const formMountNode = usePlaceBeforeTrailingCaption(contentRef, true, postProps.content);
  const showBanner = Boolean(dealsBanner);
  const bannerMountNode = useFindDealsBannerMountNode(
    contentRef,
    showBanner,
    dealsBannerContainerId,
    postProps.content,
  );

  return (
    <>
      <Post {...postProps} contentRef={contentRef} />
      {formMountNode && createPortal(<DealsLeadFormBlock {...dealsLeadForm} />, formMountNode)}
      {showBanner && dealsBanner && bannerMountNode && createPortal(<DealsBanner {...dealsBanner} />, bannerMountNode)}
    </>
  );
};
